import type { BusinessUnitStore } from '../../../../stores/business-unit';
import {
    SELECT_ALL_VALUE,
    useConstructBusinessUnitTreeData,
} from '../../shared/hooks/use-construct-business-unit-tree-data';

interface Props {
    businessUnitStore: BusinessUnitStore;
}

export const useConstructTreeData = ({ businessUnitStore }: Props) => {
    const {
        treeData,
        allProvinceValues: allProvinceIds,
        businessUnitToProvincesMap,
    } = useConstructBusinessUnitTreeData({
        businessUnitStore,
        getProvinceValue: (province) => province.id,
    });

    return {
        treeData,
        allProvinceIds,
        businessUnitToProvincesMap,
    };
};

export { SELECT_ALL_VALUE };
